import { Outlet } from "react-router-dom"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { TooltipProvider } from "@/components/ui/tooltip"
import { AppSidebar } from "./AppSidebar"
import { AppTopbar } from "./AppTopbar"

export function MainLayout() {
  return (
    <TooltipProvider delayDuration={300}>
      {/* h-svh + overflow-hidden: powłoka ma stałą wysokość ekranu, a scroll dzieje się
          wewnątrz <main>. Bez tego min-h-svh rośnie z treścią i strony h-full (np. detal
          umowy z zakładkami) nie mają sufitu - element pisania w Dyskusjach uciekał pod ekran. */}
      <SidebarProvider className="h-svh overflow-hidden">
        <AppSidebar />
        <SidebarInset className="min-h-0">
          <AppTopbar />
          <main className="min-h-0 flex-1 overflow-auto p-4 md:p-6 lg:p-8">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  )
}
